






import { Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class App extends Vue {
  /**
   * Mirrors the active theme onto the <html> root element.
   *
   * Vuetify only stamps `theme--dark` on the `.v-application` div, which cannot
   * style its <html> ancestor. The browser paints the page canvas (the overscroll
   * / rubber-band area revealed beyond the app, e.g. on macOS) from the <html>
   * background, so in dark mode the unthemed white root showed through when
   * scrolling past the content. Reflecting the theme here keeps that area dark.
   * `immediate` applies it on boot; the watcher re-applies on every toggle.
   */
  @Watch("$vuetify.theme.dark", { immediate: true })
  onThemeChanged(isDark: boolean) {
    document.documentElement.classList.toggle("dark-root", isDark);
  }
}
